import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';

import { AuthGuard } from './auth/auth-guard.service';

/**Array dei percorsi principali disponibili */
const appRoutes: Routes = [
    { path: 'auth', loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule) },
    { path: '', canActivate: [AuthGuard], loadChildren: () => import('./ricerca/ricerca.module').then(m => m.RicercaModule) },
    { path: '**', redirectTo: '/' }

];

@NgModule({
    imports: [
        RouterModule.forRoot(appRoutes, { preloadingStrategy: PreloadAllModules, relativeLinkResolution: 'legacy' }),
        TranslateModule
    ],
    exports: [RouterModule]
})
export class AppRoutingModule { }